module.exports = __webpack_public_path__ + "static/media/78.86fc8261.jpg";